import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'

import JobModuleBase from '../JobModuleBase'
import LineItemsList from './LineItemsList'
import AddLineItem from './AddLineItem'
import LineItemsDetails from './LineItemsDetails'
import TextParser from '../common/TextParser'
import MultiItemsConfirmationDialog, { MultiItems } from './MultiItemsConfirmationDialog'

class LineItemsModule extends JobModuleBase {

  static propTypes = {
    userId: PropTypes.string.isRequired,
    jobInfo: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      items: {},
      totals: {},
      adding: false,
      showMultiItemsConfirmation: false
    }
  }

  componentWillMount() {
    this.addLineItemsListListener()
    this.addTotalsAllocationListener()
  }

  componentWillUnmount() {
    this.removeLineItemsListListener()
    this.removeTotalsAllocationListener()
  }

  getLineItemsListDbPath = () => {
    return `${this.getExtendedModulesDbPath()}/list`
  }

  getLineItemsItemDbPath = (id) => {
    return `${this.getExtendedModulesDbPath()}/list/${id}`
  }

  /**
   * Pointer to the allocation table. Need to query the totals
   * to compute each item progress.
   */
  getTotalsAllocationDbPath = () => {
    return `/allocation/${this.props.jobInfo.id}`
  }

  addLineItemsListListener = () => {
    firebase.database()
      .ref(this.getLineItemsListDbPath())
      .on('value', this.onLineItemsValue)
  }

  removeLineItemsListListener = () => {
    firebase.database()
      .ref(this.getLineItemsListDbPath())
      .off('value', this.onLineItemsValue)
  }

  addTotalsAllocationListener = () => {
    firebase.database()
      .ref(this.getTotalsAllocationDbPath())
      .on('value', this.onAllocationTotalsValue)
  }

  removeTotalsAllocationListener = () => {
    firebase.database()
      .ref(this.getTotalsAllocationDbPath())
      .off('value', this.onAllocationTotalsValue)
  }

  onLineItemsValue = snapshot => {
    const list = snapshot && snapshot.val()
    this.setState({
      items: list || {}
    })
  }

  onAllocationTotalsValue = snapshot => {
    const totals = snapshot && snapshot.val()
    this.setState({
      totals: totals || {}
    })
  }

  handleItemAdd = item => {
    const namesList = TextParser.parse(item.name)
    if (namesList.length > 1) {
      this.setState({
        showMultiItemsConfirmation: true,
        item,
        namesList
      })
    }
    else {
      this.addLineItems(Object.assign(item, { name: [ item.name ] }))
    }
  }

  handleMultiItemsConfirmationResult = result => {
    if (result === MultiItems) {
      this.addLineItems(Object.assign(this.state.item, { name: this.state.namesList }))
    }
    else {
      this.addLineItems(Object.assign(this.state.item, { name: [ this.state.item.name ] }))
    }
    this.setState({
      showMultiItemsConfirmation: false
    })
  }

  handleMultiItemsConfirmationCancelled = () => {
    this.setState({
      showMultiItemsConfirmation: false
    })
  }

  addLineItems = item => {
    for (const name of item.name) {
      const dbList = firebase.database().ref(this.getLineItemsListDbPath())
      const key = dbList.push().key
      dbList.child(key).set({
        id: key,
        creatorId: this.props.userId,
        creationTimestamp: firebase.database.ServerValue.TIMESTAMP,
        name: name,
        foremansTarget: item.foremansTarget,
        laborersTarget: item.laborersTarget
      })
    }
    this.setState({
      adding: false
    })
  }

  handleItemEdited = (item, newValues) => {
    const itemRef = firebase.database()
      .ref(this.getLineItemsItemDbPath(item.id))
    item.name = newValues.name
    item.foremansTarget = newValues.foremansTarget
    item.laborersTarget = newValues.laborersTarget
    itemRef.set(item)
  }

  handleItemDelete = (item) => {
    const itemRef = firebase.database()
      .ref(this.getLineItemsItemDbPath(item.id))
    item.deleted = true
    itemRef.set(item)
  }

  handleAddItemClicked = () => {
    this.setState({
      adding: true
    })
  }

  handleAddCancelled = () => {
    this.setState({
      adding: false
    })
  }

  render() {
    return (
      <div style={styles.container}>
        <LineItemsList
          jobInfo={this.props.jobInfo}
          items={this.state.items}
          totals={this.state.totals}
          onItemEdited={this.handleItemEdited}
          onItemDelete={this.handleItemDelete} />
        { this.state.adding
          ? <AddLineItem
            style={styles.addContainer}
            onAddCancelled={this.handleAddCancelled}
            onItemChange={this.handleItemAdd} />
          : <div style={styles.addText} onClick={this.handleAddItemClicked}>Add line item ...</div>
        }
        <LineItemsDetails
          open={this.props.openLineItemsDetails}
          moduleRef={this.props.moduleRef}
          jobInfo={this.props.jobInfo}
          items={this.state.items}
          onRequestClose={this.props.onRequestClose} />
        <MultiItemsConfirmationDialog
          open={this.state.showMultiItemsConfirmation}
          onDialogResult={this.handleMultiItemsConfirmationResult}
          onRequestClose={this.handleMultiItemsConfirmationCancelled} />
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  addContainer: {
    marginTop: 8
  },

  addText: {
    cursor: 'pointer',
    color: '#356992',
    marginTop: 8,
    fontSize: 14
  }

}

export default connect(state => ({ userId: state.firebase.userAuth.id }))(LineItemsModule)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItemsModule.js